import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { DetalleOrdenTrabajoDTO } from "app/main/apps/shared/interfaces/detalle-orden-trabajo.interface";

@Component({
    selector: "app-dialog-evaluar",
    templateUrl: "./dialog-evaluar.component.html",
    styleUrls: ["./dialog-evaluar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogEvaluarComponent implements OnInit {
    evaluacion: number;
    constructor(
        public dialogRef: MatDialogRef<DialogEvaluarComponent>,
        @Inject(MAT_DIALOG_DATA)
        public oott: DetalleOrdenTrabajoDTO
    ) {}

    ngOnInit(): void {
        //console.log(this.oott);
    }

    setEvaluacion(evaluacion) {
        //console.log(evaluacion);
        this.evaluacion = evaluacion;
    }
}
